export default function macros(state = [], action) {
    switch (action.type) {
        case 'ADD_CURRENT':
            return {
                ...state,
                macro: action.macro,
            }
        default:
            return state;
    }
}
